import React from 'react';

import { InputStyle, InputWrapper, ErrorMessage, Label } from './input.style'
import { InputProps } from '../types'
import deleteIcon from '../../assets/images/Icon.svg'

const Input: React.FC<InputProps> = ({name, placeholder, label = '',
                                                type = 'text', invalid = false,
                                                disabled = false, className, value,
                                                errorMessage, onChange, onBlur, deleteValueClick}) => {
    return (
        <InputWrapper className={className}>
            <Label component='legend' disabled={disabled} invalid={invalid}>{ label }</Label>
            <InputStyle
                name={name}
                onBlur={onBlur}
                value={value}
                placeholder={placeholder}
                type={type}
                invalid={invalid}
                disabled={disabled}
                variant='outlined'
                onChange={onChange}
                />
            { errorMessage && <ErrorMessage variant='body1' component='p'>
                { errorMessage }
            </ErrorMessage> }
            { deleteValueClick && <div className="delete" onClick={deleteValueClick}>
                <img src={deleteIcon}/>
            </div> }
        </InputWrapper>
    );
};

export { Input }
